import { useEffect } from 'react';
import { observer } from 'mobx-react';
import { useStore } from '../../store/store';
import { DATA_SOURCE_META, LEGEND_ITEMS } from '../../utils/constants/dataSources';

/**
 * TD-2352 — Floating, bottom-centred data-source legend + body-class owner.
 *
 * Decodes the headline colours into their four source categories. Rendered only while the
 * "Show data sources" toggle is on (UtilsStore.showDataSources). Fixed to the viewport so it
 * stays visible while the user scrolls. Because it's mounted once per company-data page, it also
 * owns mirroring `showDataSources` onto `<body>` as `show-data-sources` (the class the headline
 * colouring CSS keys off) — decoupled from wherever the toggle control itself lives.
 */
const DataSourceFloatingLegend = observer(() => {
  const { utilsStore } = useStore();
  const on = utilsStore.showDataSources;

  useEffect(() => {
    document.body.classList.toggle('show-data-sources', on);
    return () => document.body.classList.remove('show-data-sources');
  }, [on]);

  if (!on) {
    return null;
  }

  return (
    <div className="data-source-floating-legend">
      <span className="dsl-title">Data sources</span>
      {LEGEND_ITEMS.map((source) => {
        const meta = DATA_SOURCE_META[source];
        return (
          <span key={source} className="dsl-key">
            <span className={`dsl-sw p-${meta.className}`} aria-hidden="true" />
            {meta.label}
          </span>
        );
      })}
    </div>
  );
});

export default DataSourceFloatingLegend;
